export default "__VITE_ASSET__BreSvgvO__"